import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { tradeOrderTypeAtom } from '@root/features/trade/trading/atoms'

import { TradingControlsButtonBase } from '../../desktop/trading-controls-button/trading-controls-button-base'

import type { BuyControlsModel } from '../../../atoms/common'
import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  model: BuyControlsModel
} & ClassNameProps

export const TradingControlsBuyButton: React.FC<Props> = ({
  pair,
  className,
  model,
}) => {
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)
  const [swapRequestState] = useAtom(model.executeSwapModel)
  const [quoteState] = useAtom(model.quoteModel.quoteStateAtom)
  const [validation] = useAtom(model.validationAtom)
  const [amount] = useAtom(model.amountInputModel.amountAtom)
  const { createOrderAction, createOrderRequestAtom } = model.limitModel

  const retryQuote = useAction(model.quoteModel.forceRetry)
  const executeSwap = useAction(model.executeSwapModel.execute)
  const createOrder = useAction(createOrderAction)
  const [createOrderRequest] = useAtom(createOrderRequestAtom)
  const [limitReceiveAmount] = useAtom(model.limitModel.receiveAtom)

  const quoteOutputAmountCurrency = quoteState.value?.outputAmount
  const quoteInputAmountBase = quoteState.value?.inputAmount

  if (tradeOrderType === 'limit') {
    return (
      <Root
        variant="buy"
        onClick={() => createOrder({ settingsOverride: undefined })}
        className={className}
        quoteState={quoteState}
        onQuoteRetry={retryQuote}
        requestState={createOrderRequest}
        validation={validation}
        pair={pair}
        amount={amount}
        currencyAmount={limitReceiveAmount}
        baseAmount={amount}
      />
    )
  }

  return (
    <Root
      variant="buy"
      onClick={() => executeSwap()}
      className={className}
      quoteState={quoteState}
      onQuoteRetry={retryQuote}
      requestState={swapRequestState}
      validation={validation}
      pair={pair}
      amount={amount}
      currencyAmount={quoteOutputAmountCurrency}
      baseAmount={quoteInputAmountBase}
    />
  )
}

const Root = styled(TradingControlsButtonBase)``
